import { gql } from "graphql-request";
import { requestAndFormat } from "../utils";

export const statusChoicesQuery = (params: {
	boardId: string;
	columnId: string;
}) =>
	requestAndFormat(
		{
			defaultParams: {},
			gql: gql`
                query GetStatusChoices($boardId: ID!, $columnId: String!) {
                    boards(ids: [$boardId]) {
                        id
                        columns(ids: [$columnId]) {
                            id
                            settings_str
                        }
                    }
                }`,
			resultKey: "boards[0].columns[0].settings_str",
			skipMondayFormatting: true,
			outType: "" as string,
		},
		params,
	);
